import React, { useEffect, useState } from "react";
import { API, fileUpload, get } from "../../config";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { MyProfileSchema } from "../../lib/Validation";
import ProfileUpload from "../../components/ProfileUpload";
import CustomLabelText from "../../components/CustomLabelText";
import { Label } from "../../components/ui/label";
import { PhoneInput } from "../../components/ui/phone-input";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import GoogleAuth from "../../assets/images/authenticator.png";
import MicroAuth from "../../assets/images/microsoft-authenticator.png";
import { useUser } from "../../lib/context/UserContext";
import { Switch } from "../../components/ui/switch";
import MultiFileUpload from "../../components/MultiFileUpload";

const MyProfile = ({ setLoading, loading }) => {
  const [userData, setUserData] = useState();
  const navigate = useNavigate();
  const { updateUserData } = useUser();
  const roleType = localStorage.getItem("roleType");

  const profilePic = userData?.profile_pic ? userData?.profile_pic : "";
  const [selectedFile, setSelectedFile] = useState(profilePic);
  const [userId, setUserId] = useState();
  const [files, setFiles] = useState();

  useEffect(() => {
    setUserId(userData?.id);
    userData?.profile_pic &&
      typeof userData?.profile_pic === "string" &&
      setSelectedFile(userData?.profile_pic);
  }, [userData]);

  useEffect(() => {
    setSelectedFile(selectedFile);
  }, [selectedFile]);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const { data } = await get(`${API.GET_USER_PROFILE}`);
        setFiles(data?.data?.files);
        if (data) {
          updateUserData(data?.data);
        }
        setUserData(data?.data);
        setLoading(false);
      } catch (e) {
        setUserData(null);
        setLoading(false);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFormSubmit = async (value) => {
    try {
      setLoading(true);
      const formData = new FormData();
      value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
      value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";

      formData.append("first_name", value?.first_name ? value?.first_name : "");
      formData.append("last_name", value?.last_name ? value?.last_name : "");
      formData.append("phone", value?.phone ? value?.phone : "");
      formData.append("mobile", value?.mobile ? value?.mobile : "");
      formData.append("email", value?.email ? value?.email : "");
      formData.append(
        "profile_pic",
        value?.profile_pic ? value?.profile_pic : "",
      );

      formData.append("is_compliance", value?.is_compliance ? 1 : 0);
      formData.append("is_senior_manager", value?.is_senior_manager ? 1 : 0);

      if (files?.length > 0) {
        for (let fileIndex = 0; fileIndex < files?.length; fileIndex++) {
          if (files[fileIndex]?.id) {
            formData.append(`file_ids[${fileIndex}]`, files[fileIndex]?.id);
          }
          formData.append(
            `files[${fileIndex}]`,
            files[fileIndex]?.url
              ? files[fileIndex]?.url
              : files[fileIndex]?.file,
          );
        }
      }

      const { data } = await fileUpload(
        `${API.UPDATE_PROFILE}/${userId}`,
        formData,
      );
      if (data.status === 200) {
        setLoading(false);
        const { data } = await get(`${API.GET_USER_PROFILE}`);
        setFiles(data?.data?.files);
        let userDetailData = data?.data;
        if (data) {
          updateUserData(data?.data);
        }
        setUserData(userDetailData);
        localStorage.setItem("ProfilePhoto", userDetailData?.profile_pic);
        localStorage.setItem(
          "Name",
          userDetailData?.first_name
            ? userDetailData?.first_name
            : userDetailData?.last_name,
        );
        navigate("/account-settings?tab=my-profile");
      }
      return data;
    } catch (error) {
      setLoading(false);
    }
  };

  const changeEmail = (e) => {
    e.preventDefault();
    navigate("/2fa/change?item=email");
  };
  const handleAuthentication = () => {
    navigate("/2fa/register?page=back");
  };
  return (
    <Formik
      initialValues={{
        first_name: userData?.first_name ? userData?.first_name : "",
        last_name: userData?.last_name ? userData?.last_name : "",
        phone: userData?.phone
          ? userData?.phone[0] === "+"
            ? userData?.phone
            : `+${userData?.phone}`
          : "",
        mobile: userData?.mobile
          ? userData?.mobile[0] === "+"
            ? userData?.mobile
            : `+${userData?.mobile}`
          : "",
        email: userData?.email ? userData?.email : "",
        profile_pic: userData?.profile_pic ? userData?.profile_pic : "",
        backup_email: userData?.backup_email ? userData?.backup_email : "",
        is_compliance: userData?.is_compliance ? true : false,
        is_senior_manager: userData?.is_senior_manager ? true : false,
      }}
      enableReinitialize
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={MyProfileSchema}
      onSubmit={handleFormSubmit}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        setFieldValue,
        handleSubmit,
        isValid,
      }) => (
        <form onSubmit={handleSubmit} noValidate>
          <div>
            <div className="md:flex gap-5">
              <ProfileUpload
                path={values?.profile_pic}
                pathData={values?.first_name?.charAt(0)}
                setFieldValue={setFieldValue}
                keyName={"profile_pic"}
              />
              <div className="grid gap-4 flex-1">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="first_name">
                      <CustomLabelText
                        required={true}
                        labelText="First name"
                        errorField={errors?.first_name}
                      />
                    </Label>
                    <Input
                      id="first_name"
                      placeholder="Enter First Name"
                      required
                      name="first_name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.first_name}
                      className={
                        errors?.first_name &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="last_name">
                      <CustomLabelText
                        required={true}
                        labelText="Last name"
                        errorField={errors?.last_name}
                      />
                    </Label>
                    <Input
                      id="last_name"
                      placeholder="Enter Last Name"
                      required
                      name="last_name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.last_name}
                      className={
                        errors?.last_name &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="phone">
                      <CustomLabelText
                        required={false}
                        labelText="Phone"
                        errorField={errors?.phone}
                      />
                    </Label>
                    <PhoneInput
                      onChange={(e) => {
                        setFieldValue("phone", e);
                      }}
                      value={values?.phone}
                      defaultValue={"+61"}
                      defaultCountry={"AU"}
                      minLength={15}
                      maxLength={15}
                      onBlur={handleBlur}
                      className={
                        errors?.phone &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="mobile">
                      <CustomLabelText
                        required={false}
                        labelText="Mobile"
                        errorField={errors?.mobile}
                      />
                    </Label>
                    <PhoneInput
                      onChange={(e) => {
                        setFieldValue("mobile", e);
                      }}
                      value={values?.mobile}
                      defaultValue={"+61"}
                      defaultCountry={"AU"}
                      minLength={15}
                      maxLength={15}
                      onBlur={handleBlur}
                      className={
                        errors?.mobile &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="email">
                      <CustomLabelText
                        required={true}
                        labelText="Email"
                        errorField={errors?.email}
                      />
                    </Label>
                    <Input
                      id="email"
                      type="email"
                      placeholder="m@example.com"
                      required
                      autoComplete="off"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.email}
                      className={
                        errors?.email &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  {roleType === "Admin" ? (
                    <></>
                  ) : (
                    <>
                      <div className="flex items-center space-x-2">
                        <span className="text-sm font-medium">
                          Compliance Officer
                        </span>
                        <Switch
                          checked={values?.is_compliance}
                          onCheckedChange={(e) =>
                            setFieldValue("is_compliance", e)
                          }
                          className="data-[state=checked]:bg-webPrimary"
                        />
                      </div>
                      <div className="flex items-center space-x-2">
                        <span className="text-sm font-medium">
                          Governing Body
                        </span>
                        <Switch
                          checked={values?.is_senior_manager}
                          onCheckedChange={(e) =>
                            setFieldValue("is_senior_manager", e)
                          }
                          className="data-[state=checked]:bg-webPrimary"
                        />
                      </div>
                    </>
                  )}
                </div>

                <div className="grid gap-2">
                  <Label htmlFor="files">
                    <CustomLabelText
                      required={false}
                      labelText="Documents"
                      errorField={errors?.documents}
                    />
                  </Label>
                  <MultiFileUpload files={files} setFiles={setFiles} />
                </div>
                <div className="bg-muted p-4 rounded-lg">
                  <div className="flex justify-between mb-2">
                    <p className="md:text-2xl text-xl -mt-1">
                      Two-Factor Authentication
                    </p>
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        handleAuthentication();
                      }}
                    >
                      {parseInt(userData?.google2fa_enable) === 1
                        ? "Reset"
                        : "Set up"}
                    </Button>
                  </div>
                  {userData?.backup_email ? (
                    <div className="flex gap-3 lg:flex-nowrap flex-wrap">
                      <div className="flex w-[365px] gap-2 bg-background p-2 items-end rounded-lg">
                        <div className="flex-1 grid gap-2">
                          <Label htmlFor="backup_email">
                            <CustomLabelText
                              required={true}
                              labelText="Backup Email Address"
                              errorField={errors?.backup_email}
                            />
                          </Label>
                          <Input
                            id="backup_email"
                            type="backup_email"
                            placeholder="m@example.com"
                            required
                            autoComplete="off"
                            name="backup_email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={true}
                            value={values?.backup_email}
                            className={
                              errors?.backup_email
                                ? `focus-visible:ring-red-500 border-red-500 w-full`
                                : `w-full`
                            }
                          />
                        </div>
                        <div className="form-group tetra-width">
                          <Button name="changeEmail" onClick={changeEmail}>
                            Change
                          </Button>
                        </div>
                      </div>
                      <div className="flex flex-col gap-2 bg-background w-fit p-2 rounded-lg">
                        <Label htmlFor="backup_email">
                          <CustomLabelText
                            labelText="Authentication Method"
                            errorField={errors?.backup_email}
                          />
                        </Label>
                        <span className="flex gap-1 items-center pr-1">
                          <img
                            alt="authenticator"
                            src={GoogleAuth}
                            width={30}
                            height={30}
                          />
                          <span className="pr-1">|</span>
                          <img
                            alt="authenticator"
                            src={MicroAuth}
                            width={30}
                            height={30}
                          />
                          Authenticator App
                        </span>
                      </div>
                    </div>
                  ) : (
                    <p className="text-sm">
                      Multi-factor authentication adds a second layer of
                      security to your account to help prevent unauthorised
                      access.
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-action">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default MyProfile;
